<template>
  <div
    v-if="
      permissions &&
      permissions['comunicazioni e note'] &&
      permissions['comunicazioni e note'].view_note?.enabled === true
    "
    class="grid grid-cols-12 gap-1"
  >
    <!-- BEGIN: Messagges -->
    <div class="p-2 col-span-12 xl:col-span-6 rounded-lg shadow-md mx-2">
      <div
        class="flex md:flex-row items-center justify-center bg-theme-45 rounded-md py-2 relative"
      >
        <h2 class="text-xl mr-2 nunito text-theme-40 font-bold text-center">
          Comunicazioni interne
        </h2>

        <button
          v-if="
            permissions &&
            permissions['comunicazioni e note'] &&
            permissions['comunicazioni e note'].store_note?.enabled === true
          "
          class="text-theme-41 absolute right-3 tooltipbutton"
          @click="openNewAnnotationModal('communications')"
        >
          <span class="tooltipbuttontext" style="width: 170px"
            >Aggiungi Comunicazione</span
          >
          <svg
            id="icon-Risorsa-21"
            viewBox="0 0 34 32"
            class="h-6 fill-current"
          >
            <path
              d="M17.134 27.039c-0.229-0.292-0.407-0.589-0.541-0.901-0.215-0.509-0.323-1.044-0.323-1.595 0-0.864 0.274-1.696 0.792-2.408 0.771-1.053 2.002-1.679 3.295-1.679h2.488v-2.488c0-2.254 1.833-4.087 4.087-4.087 1.096 0 2.123 0.427 2.893 1.202 0.767 0.761 1.194 1.788 1.194 2.884v2.488h1.462c0.549-0.901 0.993-1.887 1.31-2.962 1.561-5.296-0.541-10.751-4.927-13.965-2.977-2.178-6.359-3.249-10.042-3.479-5.009-0.313-9.568 0.85-13.557 3.955-5.715 4.447-6.737 11.93-2.379 17.444 0.45 0.569 0.516 1.058 0.362 1.719-0.441 1.884-1.302 3.54-2.561 4.99-0.591 0.681-0.709 1.099-0.682 1.417 0.063 0.758 1.977 0.463 2.126 0.449 2.753-0.264 5.21-1.322 7.481-2.838 1.133-0.757 2.485 0.058 3.622 0.303 0.989 0.214 2.012 0.311 3.035 0.341 0.557 0.017 1.115 0.012 1.665-0.004-0.295-0.221-0.565-0.483-0.798-0.785z"
            ></path>
            <path
              d="M32.847 23.119h-4.663v-4.663c0-0.375-0.146-0.728-0.41-0.99-0.268-0.27-0.619-0.416-0.995-0.416-0.775 0-1.406 0.631-1.406 1.406v4.663h-4.663c-0.449 0-0.861 0.211-1.13 0.578-0.18 0.247-0.276 0.534-0.276 0.828 0 0.19 0.037 0.375 0.11 0.547 0.040 0.093 0.1 0.191 0.189 0.304 0.274 0.355 0.677 0.555 1.108 0.555h4.663v4.663c0 0.295 0.095 0.579 0.274 0.823 0.272 0.37 0.683 0.582 1.131 0.582 0.539 0 1.021-0.306 1.26-0.799 0.097-0.199 0.146-0.403 0.146-0.607v-4.663h4.663c0.775 0 1.406-0.631 1.406-1.406s-0.631-1.406-1.406-1.406z"
            ></path>
          </svg>
        </button>
      </div>

      <!-- <div class="flex flex-wrap justify-around gap-2 px-1 py-1 mx-3 mt-3">
        <template v-for="(note, i) in notes.communications.note" :key="note">
          <div
            v-if="i <= 6"
            class="relative flex items-center p-3 w-40 h-40 rounded-2xl shadow bg-theme-2 mb-2 "
          >
            <div class="font-medium text-theme-41 absolute top-3 right-3">
              <i
                class="fas fa-times cursor-pointer"
                @click="deleteNote(note.id, 'communications')"
              />
            </div>
            <div class="">
              <p
                class="p-1 text-sm text-theme-43 text-center"
                v-html="note.note"
              ></p>
            </div>
          </div>
        </template>
      </div> -->
      <div
        class="overflow-y-scroll overflow-x-hidden scrollbar scrollbar-thin scrollbar-thumb-rounded-lg scroll scrollbar-thumb-theme-41 scrollbar-track-theme-2"
        style="max-height: 20vh"
      >
        <div class="flex flex-col p-1 gap-2">
          <div
            v-for="(note, item) in notes.communications.note"
            :key="item"
            class="flex items-center p-2 md:px-10 rounded-2xl shadow justify-between relative"
            :class="{ 'bg-theme-2': item % 2 !== 0 }"
          >
            <div
              class="flex flex-col lg:flex-row lg:items-baseline gap-2 flex-wrap 0"
            >
              <div
                v-if="
                  permissions &&
                  permissions['comunicazioni e note'] &&
                  permissions['comunicazioni e note'].delete_note?.enabled ===
                    true
                "
                class="font-medium text-theme-41 absolute right-3"
              >
                <i
                  class="fas fa-times cursor-pointer"
                  @click="deleteNote(note.id, 'communications')"
                />
              </div>

              <div class="flex items-baseline flex-wrap gap-2">
                <div class="w-2 h-2 bg-theme-41 rounded-full mr-2"></div>
                <div class="flex items-baseline gap-1">
                  <label class="form-label mb-0">Nota:</label>
                  <span class="font-normal text-sm" v-html="note.note"> </span>
                </div>

                <div class="text-xs ml-4 font-medium">
                  creato da:
                  <span class="italic text-xs mr-2 font-normal">
                    {{ note.first_name }} {{ note.last_name }}</span
                  >
                  <span class="italic text-xs font-normal">
                    {{ $FormatDateMin(note.last_update) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          notes &&
          notes.communications &&
          notes.communications.note &&
          notes.communications.total > 3
        "
        class="flex justify-end mt-1"
      >
        <button
          class="orange-btn"
          :class="[more_notes ? '' : 'disabilitato']"
          @click="
            showMoreNotes(
              {
                forPage: notes.communications.pagination.forPage + 1,
                page: notes.communications.pagination.page
              },
              'communications'
            )
          "
        >
          Mostra di più
        </button>
      </div>
    </div>

    <!-- END: Messagges -->

    <!-- BEGIN: Payment agreements -->
    <div
      class="p-2 col-span-12 xl:col-span-6 rounded-lg shadow-md mx-2 bg-white"
    >
      <div
        class="flex md:flex-row items-center justify-center bg-theme-45 rounded-md py-2 relative"
      >
        <h2 class="text-xl mr-2 nunito text-theme-40 font-bold text-center">
          Accordi per pagamenti
        </h2>
        <button
          v-if="
            permissions &&
            permissions['comunicazioni e note'] &&
            permissions['comunicazioni e note'].store_note?.enabled === true
          "
          class="text-theme-41 absolute right-3 tooltipbutton"
          @click="openNewAnnotationModal('payments')"
        >
          <span
            class="tooltipbuttontext"
            style="width: 130px; margin-left: -1.5rem"
            >Aggiungi Accordo</span
          >
          <svg
            id="icon-Risorsa-23"
            viewBox="0 0 25 32"
            class="h-6 fill-current"
          >
            <path
              d="M7.534 25.262l-0.001-0.014c-0.006-0.082-0.017-0.213-0.017-0.364 0-2.382 1.939-4.321 4.322-4.321h1.509v-1.509c0-1.97 1.333-3.69 3.241-4.182 0.358-0.092 0.721-0.139 1.080-0.139 1.153 0 2.238 0.45 3.055 1.266 0.339 0.339 0.614 0.725 0.82 1.143v-12.975c0-2.301-1.866-4.167-4.167-4.167h-13.208c-2.302 0-4.168 1.866-4.168 4.167v20.27c0 2.301 1.866 4.167 4.168 4.167h5.466c-0.255-0.151-0.495-0.328-0.717-0.53-0.798-0.731-1.288-1.729-1.383-2.812zM10.772 7.096c0-0.294 0.239-0.533 0.533-0.533h8.459c0.294 0 0.533 0.239 0.533 0.533v0c0 0.294-0.239 0.533-0.533 0.533h-8.459c-0.294 0-0.533-0.239-0.533-0.533v0zM11.305 9.362h8.459c0.294 0 0.533 0.239 0.533 0.533s-0.239 0.533-0.533 0.533h-8.459c-0.294 0-0.533-0.239-0.533-0.533s0.239-0.533 0.533-0.533zM11.305 12.16h8.459c0.294 0 0.533 0.239 0.533 0.533s-0.239 0.533-0.533 0.533h-8.459c-0.294 0-0.533-0.239-0.533-0.533s0.239-0.533 0.533-0.533zM4.902 13.634c-0.529-0.271-0.966-0.672-1.312-1.205-0.284-0.436-0.496-0.947-0.636-1.532h-0.643c-0.187 0-0.342-0.062-0.466-0.187s-0.187-0.275-0.187-0.453 0.062-0.329 0.187-0.453c0.124-0.124 0.28-0.187 0.466-0.187h0.47c-0.004-0.157-0.008-0.306-0.010-0.446-0.003-0.126 0.001-0.253 0.010-0.38h-0.47c-0.187 0-0.342-0.062-0.466-0.187s-0.187-0.275-0.187-0.453c0-0.187 0.062-0.339 0.187-0.459s0.28-0.18 0.466-0.18h0.645c0.14-0.586 0.352-1.095 0.634-1.525 0.346-0.528 0.784-0.928 1.312-1.199s1.117-0.406 1.765-0.406c0.373 0 0.75 0.053 1.132 0.16s0.724 0.275 1.025 0.506c0.169 0.115 0.28 0.253 0.333 0.413s0.065 0.322 0.033 0.486-0.098 0.304-0.2 0.42c-0.102 0.115-0.233 0.184-0.393 0.207s-0.338-0.020-0.533-0.126c-0.169-0.115-0.364-0.202-0.586-0.26s-0.444-0.087-0.666-0.087c-0.302 0-0.575 0.060-0.819 0.18s-0.453 0.311-0.626 0.573c-0.12 0.182-0.222 0.402-0.306 0.659h1.299c0.187 0 0.339 0.062 0.459 0.187s0.18 0.275 0.18 0.453-0.060 0.318-0.18 0.446c-0.12 0.129-0.273 0.193-0.459 0.193h-1.528c-0.003 0.114-0.004 0.234-0.004 0.36 0 0.164 0.002 0.319 0.006 0.466h1.525c0.187 0 0.339 0.062 0.459 0.187s0.18 0.275 0.18 0.453-0.060 0.329-0.18 0.453c-0.12 0.125-0.273 0.187-0.459 0.187h-1.303c0.085 0.263 0.188 0.488 0.311 0.672 0.173 0.262 0.382 0.453 0.626 0.573s0.517 0.18 0.819 0.18c0.231 0 0.448-0.029 0.653-0.087s0.408-0.144 0.613-0.26c0.195-0.098 0.373-0.136 0.533-0.113s0.291 0.091 0.393 0.207c0.102 0.116 0.166 0.249 0.193 0.4s0.015 0.304-0.033 0.459c-0.049 0.156-0.153 0.296-0.313 0.42-0.293 0.231-0.633 0.404-1.019 0.52s-0.775 0.173-1.165 0.173c-0.649 0-1.237-0.135-1.765-0.406z"
            ></path>
            <path
              d="M23.498 23.6h-4.546v-4.546c0-0.342-0.134-0.665-0.376-0.907s-0.565-0.376-0.907-0.376c-0.105 0-0.21 0.014-0.322 0.043-0.566 0.146-0.962 0.657-0.962 1.241v4.546h-4.546c-0.709 0-1.286 0.576-1.286 1.284 0 0.028 0.004 0.074 0.007 0.112 0.059 0.671 0.608 1.174 1.279 1.174h4.546v4.546c0 0.342 0.134 0.665 0.376 0.907s0.564 0.376 0.908 0.376c0.708 0 1.284-0.576 1.284-1.284v-4.546h4.546c0.708 0 1.284-0.577 1.284-1.286s-0.576-1.284-1.284-1.284z"
            ></path>
          </svg>
        </button>
      </div>

      <!-- <div class="flex flex-wrap justify-around gap-2 px-1 py-1 mx-3 mt-3">
        <template v-for="(note, i) in notes.payments.note" :key="note">
          <div
            v-if="i <= 6"
            class="relative flex items-center p-3 w-40 h-40 rounded-2xl shadow bg-theme-2 mb-2 "
          >
            <div class="font-medium text-theme-41 absolute top-3 right-3">
              <i
                class="fas fa-times cursor-pointer"
                @click="deleteNote(note.id, 'payments')"
              />
            </div>
            <div class="">
              <p
                class="p-1 text-sm text-theme-43 text-center"
                v-html="note.note"
              ></p>
            </div>
          </div>
        </template>
      </div> -->
      <div
        class="overflow-y-scroll overflow-x-hidden scrollbar scrollbar-thin scrollbar-thumb-rounded-lg scroll scrollbar-thumb-theme-41 scrollbar-track-theme-2"
        style="max-height: 20vh"
      >
        <div class="flex flex-col p-1 gap-2">
          <div
            v-for="(note, item) in notes.payments.note"
            :key="item"
            class="flex items-center gap- p-2 md:px-10 rounded-2xl shadow bg-white justify-between relative"
            :class="{ 'bg-theme-2': item % 2 !== 0 }"
          >
            <div
              class="flex flex-col lg:flex-row lg:items-baseline gap-2 flex-wrap"
            >
              <div
                v-if="
                  permissions &&
                  permissions['comunicazioni e note'] &&
                  permissions['comunicazioni e note'].delete_note?.enabled ===
                    true
                "
                class="font-medium text-theme-41 absolute right-2"
              >
                <i
                  class="fas fa-times cursor-pointer"
                  @click="deleteNote(note.id, 'payments')"
                />
              </div>
              <div class="flex items-baseline flex-wrap gap-2">
                <div class="w-2 h-2 bg-theme-41 rounded-full mr-2"></div>
                <div class="flex items-baseline gap-1">
                  <label class="form-label mb-0">Accordo:</label>
                  <span class="font-normal text-sm" v-html="note.note"> </span>
                </div>

                <div class="text-xs ml-4 font-medium">
                  creato da:
                  <span class="italic text-xs mr-2 font-normal">
                    {{ note.first_name }} {{ note.last_name }}</span
                  >
                  <span class="italic text-xs font-normal">
                    {{ $FormatDateMin(note.last_update) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          notes &&
          notes.payments &&
          notes.payments.note &&
          notes.payments.total > 3
        "
        class="flex justify-end mt-1"
      >
        <button
          class="orange-btn"
          :class="[more_accordi ? '' : 'disabilitato']"
          @click="
            showMorePayments(
              {
                forPage: notes.payments.pagination.forPage + 1,
                page: notes.payments.pagination.page
              },
              'payments'
            )
          "
        >
          Mostra di più
        </button>
      </div>
    </div>
    <!-- END: Payment agreements -->

    <!-- BEGIN: Calendar Side Menu -->
    <div
      class="p-2 col-span-12 xl:col-span-12 rounded-lg shadow-md mx-2 overflow-hidden"
      style="max-height: 40vh"
    >
      <div
        class="flex md:flex-row items-center justify-center bg-theme-45 rounded-md py-2"
      >
        <h2 class="text-xl mr-2 nunito text-theme-40 font-bold text-center">
          Ultimi appuntamenti negli ultimi 6 mesi
        </h2>
      </div>
      <div class="flex flex-col p-1 gap-2 px-3">
        <FullCalendarDraggable
          id="calendar-events"
          class="flex flex-col gap-2 overflow-y-scroll scrollbar scrollbar-thin scrollbar-thumb-rounded-lg scroll scrollbar-thumb-theme-41 scrollbar-track-theme-2"
        >
          <div class="">
            <table class="w-full">
              <thead class="h-5 t-header">
                <tr>
                  <th>Data</th>
                  <th>Motivo</th>
                  <th>Paziente</th>
                  <th>Veterinario</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in lastAppointments"
                  :key="item.id"
                  :class="[index % 2 == 0 ? 'bg-white' : 'bg-theme-2']"
                >
                  <td>
                    {{ $FormatDateMin(item.start_datetime) }}
                  </td>
                  <td>
                    {{ item.title ? item.title : '--' }}
                  </td>
                  <td>
                    {{ item.pet_name ?? '' }}
                  </td>
                  <td>
                    <div v-for="(vet, i) in item.staff_users" :key="vet">
                      <span class="text-sm">
                        {{ i > 0 ? ', ' : '' }}
                        <div class="flex items-center gap-1 justify-center">
                          <span>
                            {{ vet.first_name }}
                          </span>
                          <span>
                            {{ vet.last_name }}
                          </span>
                        </div>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            id="calendar-no-events"
            class="text-gray-600 p-3 text-center hidden"
          >
            No events yet
          </div>
        </FullCalendarDraggable>
      </div>
    </div>
    <!-- END: Calendar Side Menu -->
  </div>
  <NewAnnotationModal
    v-if="newAnnotationModal"
    :type="type"
    @close="closeNewAnnotationModal"
    @addNote="addNote"
  />
</template>

<script>
import axios from '../../gateway/backend-api'
import { mapGetters } from 'vuex'
import NewAnnotationModal from '../modals/NewAnnotationModal.vue'

export default {
  name: 'Dashboard',
  components: {
    NewAnnotationModal
  },
  props: {
    customerDetails: Object,
    notes: Object,
    newAnnotationModal: Boolean
  },
  emits: [
    'deleteNote',
    'addNote',
    'toggleNewAnnotationModal',
    'changePaginationNotes'
  ],
  data() {
    return {
      lastAppointments: [],
      type: null,
      more_appointments: false,
      more_accordi: true,
      more_notes: true
    }
  },
  computed: {
    ...mapGetters({
      permissions: 'reusableData/getPermissions'
    })
  },
  mounted() {
    axios
      .post('/' + localStorage.getItem('clinic') + '/agenda/index', {
        active_filters: { customers: [this.customerDetails.id] }
      })
      .then((res) => {
        this.lastAppointments = res.data.data
      })
  },
  methods: {
    getAgenda() {},
    deleteNote(note_id, type) {
      this.type = type
      this.$emit('deleteNote', type, note_id)
    },
    addNote(type, note) {
      this.$emit('addNote', type, note)
    },
    openNewAnnotationModal(type) {
      this.type = type
      this.$emit('toggleNewAnnotationModal', true)
    },
    closeNewAnnotationModal() {
      this.$emit('toggleNewAnnotationModal', false)
    },
    handleShowResults() {
      this.more_appointments = true
    },
    showMorePayments(pagination, type) {
      this.$emit('changePaginationNotes', pagination, type)
      if (this.notes.payments.note.length == this.notes.payments.total) {
        this.more_accordi = false
      }
    },
    showMoreNotes(pagination, type) {
      this.$emit('changePaginationNotes', pagination, type)
      if (
        this.notes.communications.note.length == this.notes.communications.total
      ) {
        this.more_notes = false
      }
    }
  }
}
</script>

<style>
.hide-results:nth-child(n + 3) {
  display: none;
}
.show-results:nth-child(n + 3) {
  display: flex;
}

/* .show-results-container {
  height: 35vh;
}

.hide-results-container {
  height: 19vh;
}  */
</style>
